import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import API_BASE_URL from "../config";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!username || !password) {
      setMessage("Please enter both username and password.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
        credentials: "include" 
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));  
        onLogin(data.user);
        navigate("/admin/upload");
      } else {
        setMessage(data.error || "Login failed.");
      }
    } catch (err) {
      console.error("Login error:", err);  
      setMessage("Network error: " + err.message);
    }

    setLoading(false);
  };

  return (

    <div>
    <header className="login-header">
      
        <h1>NZ Pure Dairy QR Code Traceability System</h1>
      </header>

    <div className="login-container">
      <div className="login-card">
        <h2>Login</h2>

        <div className="form-group">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
        </div>

        <button
          className="login-button"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        {message && <p className="login-message">{message}</p>}
      </div>
    </div>
    </div>
  );
};

export default Login;
